import React, { useState } from "react";
import { Modal } from "./Modal";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import RoomClient from "RoomClient";

export interface ExitRoomDialogProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

/**
 * 사회자 나가기 선택 (회의실 종료 / 나만 나가기 / 취소)
 */
const ExitRoomDialog = (props: ExitRoomDialogProps) => {
  const { isOpen, setIsOpen } = props;
  const { t } = useTranslation();
  const [isClosing, setIsClosing] = useState(false);

  const handleCloseRoom = async () => {
    if (isClosing) return;
    setIsClosing(true);

    // 성공 시 RoomClient 가 종료 화면으로 이동함
    const result = await RoomClient.getInstance().closeRoom();
    if (!result) {
      toast.warn(t("msg.회의실을 종료하지 못했습니다."));
      setIsClosing(false);
      setIsOpen(false);
    }
  };

  const handleLeave = () => {
    setIsOpen(false);
    RoomClient.getInstance().close();
  };

  const handleIgnoreClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <Modal isOpen={isOpen}>
      <div className="text-sm text-white select-none" onClick={handleIgnoreClick}>
        <div className="fixed inset-0 bg-black/75 z-50" />
        <div className="fixed min-w-[21.875rem] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 p-7 rounded shadow bg-[#333]">
          <div className="my-1 text-center">
            {t("msg.회의실 종료 안내")
              .split("\n")
              .map((line, idx) => (
                <span key={idx}>
                  {line}
                  <br />
                </span>
              ))}

            <div className="flex justify-center items-center mt-8 cursor-pointer">
              <button
                className="rounded border border-[#86878b] flex justify-center items-center min-w-[6rem] h-8 px-4 hover:bg-[#444] whitespace-nowrap"
                onClick={() => setIsOpen(false)}
                disabled={isClosing}
              >
                {t("취소")}
              </button>
              <button
                className="rounded border border-[#86878b] flex justify-center items-center min-w-[6rem] h-8 ml-3 px-4 hover:bg-[#444] whitespace-nowrap"
                onClick={handleLeave}
                disabled={isClosing}
              >
                {t("menu.나만 나가기")}
              </button>
              <button
                className="rounded flex justify-center items-center min-w-[6rem] h-8 ml-3 px-4 bg-blue-20 hover:bg-blue-30 whitespace-nowrap disabled:opacity-50"
                onClick={handleCloseRoom}
                disabled={isClosing}
              >
                {t("menu.회의실 종료")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExitRoomDialog;
